import { css } from '@emotion/react';
import theme from '../../styles/theme';
export const styles = {
  homePageWrapper: css`
    background: ${theme.palette.background.default};
  `,
};
